import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=d7eb6a0e&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&lang=ts&"
export * from "./AppTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=d7eb6a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7eb6a0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
